import { LabelTextObject } from "@adactive/adsum-web-map";

export const getDrawPathSectionOptions = (pathSection) => {
  const isVertical =
    pathSection.isInterGround() && Math.abs(pathSection.getInclination()) > 10;
  const min = 100;
  const max = 2100;
  return {
    drawOptions: {
      showDelay: 1000,
      speed: 0.5,
      centerOnOptions: {
        zoom: true,
        altitude: isVertical ? 0 : 45,
        time: 1500,
        fitRatio: 1.3,
        minDistance: min,
        maxDistance: max,
      },
    },
    setCurrentFloorOptions: {
      centerOnOptions: {
        zoom: true,
        altitude: isVertical ? 45 : 50,
        time: 1500,
        fitRatio: 1.3,
        minDistance: min,
        maxDistance: max,
      },
    },
  };
};

export const getDotPathSectionDrawerOptions = () => {
  return {
    center: true,
    centerOnOptions: {
      fitRatio: 1.5,
      minDistance: 200,
      altitude: 50,
    },
    speed: 0.5,
    showDelay: 1000,
  };
};

export const iconLabelStyle = {
  offset: {
    x: -100,
    y: 0,
    z: 0,
  },
  style: {
    backgroundColor: "#22419a",
    backgroundOpacity: 0.9,
    backgroundRadius: 10,
    color: "#ffffff",
    size: 10,
  },
};

export const labelStyle = {
  arrival: {
    offset: {
      x: 0,
      y: 40,
      z: 80,
    },
    style: {
      backgroundColor: "#22419a",
      backgroundOpacity: 0.9,
      backgroundRadius: 10,
      color: "#ffffff",
      size: 30,
    },
  },
  interchange: {
    offset: {
      x: 0,
      y: 40,
      z: 80,
    },
    style: {
      backgroundColor: "#22419a",
      backgroundOpacity: 0.9,
      backgroundRadius: 10,
      color: "#ffffff",
      size: 0,
    },
  },
};

export const userObjectLabel = new LabelTextObject({
  text: "You are here",
  offset: {
    x: 0,
    y: 0,
    z: 200,
  },
  scale: {
    x: 50,
    y: 50,
    z: 50,
  },
  style: {
    size: 80,
    lineHeight: 0.5,
    // marginTop: "-100px",
    // marginBottom: "-100px",
    // color: '#be272f',
    color: "#e74c3c",
    backgroundColor: "#000000",
    backgroundOpacity: ".8",
    fontWeight: "bold",
    backgroundRadius: 2.5,
  },
});

export const s3Url = process.env.REACT_APP_S3_URL;
export const url = process.env.REACT_APP_BASE_URL;
export const siteId = process.env.REACT_APP_SITE_ID;
// export const email = process.env.REACT_APP_EMAIL;
// export const password = process.env.REACT_APP_PASSWORD;
export const email = process.env.REACT_APP_EMAIL;
export const password = process.env.REACT_APP_PASSWORD;
export const esplanadeUser = process.env.ESPLANADE_USER;
export const esplanadePass = process.env.ESPLANADE_PASS;

export const informationID = {
  operatingHour: "675fc147e5cd3b5b8bb6d6a0",
  contactDetail: "6731d751550562c63c0330a1",
  escalatorLiftGuide: "6760f74bd9b83a70209be0d4",
  getInfoDetail: "676100dbd9b83a70209c2c2f",
};
